import monkeyPatch from "./monkeyPatch.js";


monkeyPatch(Array.prototype,{
    /**
     * removes Elements from Array
     * @param callback (element,index)=>boolean
     * @returns Array of deleted Elements;
     */
    remove(callback){
        return this.reduceRight((deletedConfigs,element,index,orig)=>{
            if (callback(element,index)){
                deletedConfigs.push(orig.splice(index,1)[0]);
            }
            return deletedConfigs;
        },[]);
    },

    /**
     * wie flatMap, aber ohne null / undefined und jedes Objekt garantiert nur einmal
     * @param callback
     * @return {Array}
     */
    flatMapUniq(callback) {
        return _.uniq(this.flatMap(callback).filter(x=>x!=null));
    },

    /**
     * ein effizientes .map(mapper).find(x=>x)
     */
    findMap(mapper) {
        for (let v of this) {
            const result = mapper(v);
            if (result!=null) {
                return result;
            }
        }
        return undefined;
    },

});
